import { Reducer } from 'redux';

import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';
import {
  NestedThreadDeepLinkSecondLevelLoadFulfilledAction,
  NestedThreadDeepLinkTopLevelLoadFulfilledAction,
  NestedThreadLoadFulfilledAction,
} from '../../domains/nestedThread/types';
import { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';
import {
  EditPinnedLinkTitleFulfilledAction,
  PinCampaignObjectFulfilledAction,
} from '../../domains/pinnedResources/actions.types';
import {
  ThreadPinToEventFeedFulfilledAction,
  ThreadPinToGroupFeedFulfilledAction,
  ThreadPinToTeamsMeetingFeedFulfilledAction,
  ThreadUnpinFromEventFeedFulfilledAction,
  ThreadUnpinFromGroupFeedFulfilledAction,
  ThreadUnpinFromTeamsMeetingFeedFulfilledAction,
} from '../../domains/pinnedThreads/actions.types';
import {
  PublishDirectMessageFulfilledAction,
  PublishEditMessageFulfilledAction,
  PublishEventMessageFulfilledAction,
  PublishGroupMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
  PublishReplyMessageFulfilledAction,
  PublishUserMessageFulfilledAction,
  PublishUserPollMessageFulfilledAction,
  PublishUserPraiseMessageFulfilledAction,
} from '../../domains/publishers/actions.types';
import { ResolveAttachableLinkFulfilledAction } from '../../domains/resolveAttachableLink/actions.types';
import { ResolveWebLinkFulfilledAction } from '../../domains/resolveWebLink/actions.types';
import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import {
  SecondLevelRepliesLoadLastFulfilledAction,
  SecondLevelRepliesLoadNextFulfilledAction,
  SecondLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/secondLevelReplies/actions.types';
import { ThreadListLoadFulfilledAction } from '../../domains/threadListLoad/actions.types';
import {
  ThreadLoadFulfilledAction,
  ThreadLoadNewerRepliesFulfilledAction,
  ThreadLoadOlderRepliesFulfilledAction,
} from '../../domains/threadLoad/actions.types';
import { ThreadSharesLoadFulfilledAction } from '../../domains/threadShares/actions.types';
import {
  TopLevelRepliesLoadInitialFulfilledAction,
  TopLevelRepliesLoadLastFulfilledAction,
  TopLevelRepliesLoadNextFulfilledAction,
  TopLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/topLevelReplies/actions.types';
import { moveToFulfilled } from '../types';

import { SharePointVideoLinks } from './types';
export type SharePointVideoLinkAction =
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction
  | ThreadLoadFulfilledAction
  | ThreadLoadNewerRepliesFulfilledAction
  | ThreadLoadOlderRepliesFulfilledAction
  | ThreadPinToEventFeedFulfilledAction
  | ThreadPinToGroupFeedFulfilledAction
  | ThreadPinToTeamsMeetingFeedFulfilledAction
  | ThreadUnpinFromEventFeedFulfilledAction
  | ThreadUnpinFromGroupFeedFulfilledAction
  | ThreadUnpinFromTeamsMeetingFeedFulfilledAction
  | ThreadListLoadFulfilledAction
  | PinCampaignObjectFulfilledAction
  | PublishEventMessageFulfilledAction
  | PublishGroupMessageFulfilledAction
  | PublishUserMessageFulfilledAction
  | PublishUserPollMessageFulfilledAction
  | PublishUserPraiseMessageFulfilledAction
  | PublishReplyMessageFulfilledAction
  | PublishEditMessageFulfilledAction
  | PublishDirectMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | ResolveWebLinkFulfilledAction
  | EditPinnedLinkTitleFulfilledAction
  | GroupSidebarLoadFulfilledAction
  | ResolveWebLinkFulfilledAction
  | NestedThreadLoadFulfilledAction
  | NestedThreadDeepLinkTopLevelLoadFulfilledAction
  | NestedThreadDeepLinkSecondLevelLoadFulfilledAction
  | NestedThreadListLoadFulfilledAction
  | TopLevelRepliesLoadInitialFulfilledAction
  | TopLevelRepliesLoadLastFulfilledAction
  | TopLevelRepliesLoadPreviousFulfilledAction
  | TopLevelRepliesLoadNextFulfilledAction
  | SecondLevelRepliesLoadPreviousFulfilledAction
  | SecondLevelRepliesLoadNextFulfilledAction
  | ResolveAttachableLinkFulfilledAction
  | SecondLevelRepliesLoadLastFulfilledAction
  | ThreadSharesLoadFulfilledAction;

const initialState: SharePointVideoLinks = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SharePointVideoLinks, SharePointVideoLinkAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN_PINNED_RESOURCES.PIN_OBJECT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.LOAD_NEWER_REPLIES_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.LOAD_OLDER_REPLIES_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.PIN_TO_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.PIN_TO_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.PIN_TO_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.UNPIN_FROM_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.UNPIN_FROM_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD.UNPIN_FROM_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_DIRECT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'WEBLINK.RESOLVE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'GROUP_PINNED_RESOURCES.EDIT_LINK_TITLE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'NESTED_THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_TOP_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_SECOND_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'NESTED_THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'TOP_LEVEL_REPLIES.LOAD_INITIAL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'TOP_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'TOP_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'TOP_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'SECOND_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'SECOND_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'ATTACHABLELINK.RESOLVE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'SECOND_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    case 'THREAD_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.sharePointVideoLinks);
    default:
      return state;
  }
};

export default reducer;
